<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>充值提现</el-breadcrumb-item>
			<el-breadcrumb-item>充值记录</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div style="margin-left: 10px;">状态：</div>
				<el-select size="mini" v-model="search.status" placeholder="状态" style="width: 120px;">
					<el-option key="all" label="全部" :value="-1"></el-option>
					<el-option key="add" label="未支付" :value="0"></el-option>
					<el-option key="sub" label="已支付" :value="1"></el-option>
				</el-select>
				<div>&nbsp;&nbsp;搜索：</div>
				<el-input size="mini" placeholder="SID / 账号 / 金额" v-model="search.keyword" style="margin-right: 10px; width:200px;"></el-input>
				<el-button size="mini" type="primary" @click="getData()">搜索</el-button>
				<el-button size="mini" type="warning" @click="reset()">重置</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="id" label="序号" align="center" width="120"></el-table-column>
				
				<el-table-column prop="orderSn" label="订单号" align="center" width="240">
				</el-table-column>
				
				<el-table-column prop="uid" label="店主(sid)" align="center" width="180">
					<template slot-scope="scope">
						{{scope.row.username}}({{scope.row.sid}})
					</template>
				</el-table-column>
				<el-table-column prop="usdt_amount" label="USDT" align="center" width="90">
				</el-table-column>
				<el-table-column prop="amount" label="充值金额" align="center" width="100">
				</el-table-column>
				<el-table-column prop="send_amount" label="赠送金额" align="center" width="80">
				</el-table-column>
				<el-table-column prop="status" label="状态" align="center" width="90">
					<template slot-scope="scope">
						<el-button type="info" v-if="scope.row.status==0" size="mini">待付款</el-button>
						<el-button type="success" v-if="scope.row.status==1" size="mini">已支付</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="add_time" label="下单时间" align="center">
					<template slot-scope="scope">
						{{formatTimestamp(scope.row.add_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="pay_time" label="到账时间" align="center">
					<template slot-scope="scope">
						{{formatTimestamp(scope.row.pay_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="transaction_id" label="账单流水" align="center">
				</el-table-column>
				<el-table-column prop="pay_address" label="付款方地址" align="center">
				</el-table-column>
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
		
	</div> 
</template>

<script>
	export default {
		computed:{
		},
		data(){
			return {
				search:{
					keyword:'',
					status:-1,
				},
				dialogVisible1:false,
				dialogVisible:false,
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:10,
				editInfo:{}
			}
		},
		created() {
			this.getData();
		},
		methods:{
			reset(){
				this.search = {
					keyword:'',
					status:'all',
				}
				this.getData();
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Recharge/getUsdtRecordList", {page:this.currentPage, limit:this.limit, ...this.search}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			},
			formatTimestamp(ts) {
				if(ts == 0) return '';
				// 如果是 10 位（秒），需要乘 1000 变成毫秒
				if (ts.toString().length === 10) {
					ts *= 1000
				}
				const date = new Date(ts)
			
				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')
			
				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')
			
				return `${Y}-${M}-${D} ${h}:${m}:${s}`
			}
		}
	}
</script>

